"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _axios = _interopRequireDefault(require("axios"));
var _formik = require("formik");
var _constantes = require("../constantes");
var _uf = _interopRequireDefault(require("./uf"));
var _pais = _interopRequireDefault(require("./pais"));
var _municipio = _interopRequireDefault(require("./municipio"));
var _moment = _interopRequireDefault(require("moment"));
var _fieldNames = require("./fieldNames");
var _core = require("@stt-componentes/core");
var _elements;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var elements = (_elements = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_elements, _fieldNames.NOME, function (_ref) {
  var campo = _ref.campo,
    errors = _ref.errors,
    strings = _ref.strings,
    pacientePadrao = _ref.pacientePadrao,
    submitCount = _ref.submitCount,
    field = _ref.field,
    meta = _ref.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttInput, _extends({
    inputProps: {
      maxLength: 100
    }
  }, field, {
    label: strings.nome,
    required: campo.obrigatorio,
    disabled: campo.somenteLeitura || pacientePadrao,
    onInput: function onInput(e) {
      return campo.uppercase && (e.target.value = ("" + e.target.value).toUpperCase());
    },
    error: errors && (meta.touched && errors[_fieldNames.NOME] || errors[_fieldNames.NOME] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.NOME] || errors[_fieldNames.NOME] && submitCount > 0) ? errors[_fieldNames.NOME] : undefined
  }));
}), _fieldNames.NOME_MAE, function (_ref2) {
  var campo = _ref2.campo,
    errors = _ref2.errors,
    strings = _ref2.strings,
    submitCount = _ref2.submitCount,
    field = _ref2.field,
    meta = _ref2.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttInput, _extends({
    inputProps: {
      maxLength: 100
    }
  }, field, {
    label: strings.nomeMae,
    required: campo.obrigatorio,
    disabled: campo.somenteLeitura,
    onInput: function onInput(e) {
      return campo.uppercase && (e.target.value = ("" + e.target.value).toUpperCase());
    },
    error: errors && (meta.touched && errors[_fieldNames.NOME_MAE] || errors[_fieldNames.NOME_MAE] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.NOME_MAE] || errors[_fieldNames.NOME_MAE] && submitCount > 0) ? errors[_fieldNames.NOME_MAE] : undefined
  }));
}), _fieldNames.CPF, function (_ref3) {
  var campo = _ref3.campo,
    errors = _ref3.errors,
    strings = _ref3.strings,
    pacientePadrao = _ref3.pacientePadrao,
    submitCount = _ref3.submitCount,
    dadosCadastroOriginal = _ref3.dadosCadastroOriginal,
    contextoCadastroBasico = _ref3.contextoCadastroBasico,
    field = _ref3.field,
    meta = _ref3.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttMaskedInput, _extends({}, field, {
    mask: "cpf",
    label: strings.cpf,
    required: campo.obrigatorio,
    disabled: !contextoCadastroBasico && (campo.somenteLeitura || dadosCadastroOriginal.cpf !== null && dadosCadastroOriginal.cpf !== '' || pacientePadrao),
    error: errors && (meta.touched && errors[_fieldNames.CPF] || errors[_fieldNames.CPF] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.CPF] || errors[_fieldNames.CPF] && submitCount > 0) ? errors[_fieldNames.CPF] : undefined
  }));
}), _fieldNames.CNS, function (_ref4) {
  var campo = _ref4.campo,
    errors = _ref4.errors,
    strings = _ref4.strings,
    pacientePadrao = _ref4.pacientePadrao,
    submitCount = _ref4.submitCount,
    dadosCadastroOriginal = _ref4.dadosCadastroOriginal,
    contextoCadastroBasico = _ref4.contextoCadastroBasico,
    field = _ref4.field,
    meta = _ref4.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttMaskedInput, _extends({}, field, {
    mask: "cns",
    label: strings.cns,
    required: campo.obrigatorio,
    disabled: !contextoCadastroBasico && (campo.somenteLeitura || dadosCadastroOriginal.cns !== null && dadosCadastroOriginal.cns !== '' || pacientePadrao),
    error: errors && (meta.touched && errors[_fieldNames.CNS] || errors[_fieldNames.CNS] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.CNS] || errors[_fieldNames.CNS] && submitCount > 0) ? errors[_fieldNames.CNS] : undefined
  }));
}), _fieldNames.RACA, function (_ref5) {
  var campo = _ref5.campo,
    errors = _ref5.errors,
    strings = _ref5.strings,
    submitCount = _ref5.submitCount,
    racas = _ref5.racas,
    form = _ref5.form,
    field = _ref5.field,
    meta = _ref5.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttAutocomplete, {
    inputprops: {
      name: field.name,
      label: strings.racaEtnia,
      required: campo.obrigatorio,
      error: errors && (meta.touched && errors[_fieldNames.RACA] || errors[_fieldNames.RACA] && submitCount > 0) ? errors[_fieldNames.RACA] : undefined
    },
    getOptionLabel: function getOptionLabel(option) {
      return (option === null || option === void 0 ? void 0 : option.descricao) || '';
    },
    getOptionSelected: function getOptionSelected(option, val) {
      return (option === null || option === void 0 ? void 0 : option.id) === (val === null || val === void 0 ? void 0 : val.id);
    },
    options: racas,
    disabled: campo.somenteLeitura,
    value: field.value,
    onBlur: field.onBlur,
    onChange: function onChange(e, item) {
      return form.setFieldValue(_fieldNames.RACA, item || null);
    }
  });
}), _fieldNames.DATA_NASCIMENTO, function (_ref6) {
  var campo = _ref6.campo,
    errors = _ref6.errors,
    strings = _ref6.strings,
    pacientePadrao = _ref6.pacientePadrao,
    submitCount = _ref6.submitCount,
    dadosCadastroOriginal = _ref6.dadosCadastroOriginal,
    contextoCadastroBasico = _ref6.contextoCadastroBasico,
    form = _ref6.form,
    field = _ref6.field,
    meta = _ref6.meta;
  var erroAtual;
  if (form.errors) {
    erroAtual = form.errors[_fieldNames.DATA_NASCIMENTO];
  }
  return /*#__PURE__*/_react["default"].createElement(_core.SttDatePicker, {
    label: strings.dataNascimento,
    inputprops: {
      name: field.name
    },
    disableFuture: true,
    maxDate: new Date(),
    invalidDateMessage: strings.dataInvalida,
    maxDateMessage: strings.erroDataFutura,
    error: errors && (meta.touched && errors[_fieldNames.DATA_NASCIMENTO] || errors[_fieldNames.DATA_NASCIMENTO] && submitCount > 0) ? true : false,
    onError: function onError(error) {
      if (error && error !== erroAtual) {
        form.setFieldError(_fieldNames.DATA_NASCIMENTO, error);
      }
    },
    helperText: errors && (meta.touched && errors[_fieldNames.DATA_NASCIMENTO] || errors[_fieldNames.DATA_NASCIMENTO] && submitCount > 0) ? errors[_fieldNames.DATA_NASCIMENTO] : undefined,
    required: campo.obrigatorio,
    disabled: !contextoCadastroBasico && (campo.somenteLeitura || dadosCadastroOriginal.dataNascimento !== null || pacientePadrao),
    value: field.value,
    onBlur: function onBlur() {
      form.setFieldTouched(_fieldNames.DATA_NASCIMENTO, true);
    },
    onChange: function onChange(date) {
      return form.setFieldValue(_fieldNames.DATA_NASCIMENTO, date, true);
    }
  });
}), _fieldNames.IDADE, function (_ref7) {
  var campo = _ref7.campo,
    strings = _ref7.strings,
    idade = _ref7.idade,
    contextoCadastroBasico = _ref7.contextoCadastroBasico;
  return !contextoCadastroBasico && /*#__PURE__*/_react["default"].createElement(_core.SttInput, {
    inputProps: {
      maxLength: 100
    },
    label: strings.idade,
    disabled: campo.somenteLeitura,
    value: idade
  });
}), _fieldNames.PESO, function (_ref8) {
  var campo = _ref8.campo,
    errors = _ref8.errors,
    strings = _ref8.strings,
    submitCount = _ref8.submitCount,
    contextoCadastroBasico = _ref8.contextoCadastroBasico,
    field = _ref8.field,
    meta = _ref8.meta;
  return !contextoCadastroBasico && /*#__PURE__*/_react["default"].createElement(_core.SttNumberInput, _extends({
    inputProps: {
      maxLength: 3
    }
  }, field, {
    label: strings.peso,
    required: campo.obrigatorio,
    disabled: campo.somenteLeitura,
    error: errors && (meta.touched && errors[_fieldNames.PESO] || errors[_fieldNames.PESO] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.PESO] || errors[_fieldNames.PESO] && submitCount > 0) ? errors[_fieldNames.PESO] : undefined
  }));
}), _fieldNames.ALTURA, function (_ref9) {
  var campo = _ref9.campo,
    errors = _ref9.errors,
    strings = _ref9.strings,
    submitCount = _ref9.submitCount,
    contextoCadastroBasico = _ref9.contextoCadastroBasico,
    field = _ref9.field,
    meta = _ref9.meta;
  return !contextoCadastroBasico && /*#__PURE__*/_react["default"].createElement(_core.SttNumberInput, _extends({
    inputProps: {
      maxLength: 3
    }
  }, field, {
    label: strings.altura,
    required: campo.obrigatorio,
    disabled: campo.somenteLeitura,
    error: errors && (meta.touched && errors[_fieldNames.ALTURA] || errors[_fieldNames.ALTURA] && submitCount > 0) && submitCount > 0 ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.ALTURA] || errors[_fieldNames.ALTURA] && submitCount > 0) && submitCount > 0 ? errors[_fieldNames.ALTURA] : undefined
  }));
}), _fieldNames.GENERO, function (_ref0) {
  var campo = _ref0.campo,
    errors = _ref0.errors,
    strings = _ref0.strings,
    pacientePadrao = _ref0.pacientePadrao,
    submitCount = _ref0.submitCount,
    generos = _ref0.generos,
    form = _ref0.form,
    field = _ref0.field,
    meta = _ref0.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttAutocomplete, {
    inputprops: {
      name: field.name,
      label: strings.sexo,
      required: campo.obrigatorio,
      error: errors && (meta.touched && errors[_fieldNames.GENERO] || errors[_fieldNames.GENERO] && submitCount > 0) ? errors[_fieldNames.GENERO] : undefined
    },
    getOptionLabel: function getOptionLabel(option) {
      return option && option.descricao || '';
    },
    getOptionSelected: function getOptionSelected(option, val) {
      return option && val && option.id === val.id;
    },
    options: generos,
    disabled: campo.somenteLeitura || pacientePadrao,
    value: field.value,
    onBlur: field.onBlur,
    onChange: function onChange(e, item) {
      return form.setFieldValue(_fieldNames.GENERO, item || null);
    }
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_elements, _fieldNames.PROFISSAO, function (_ref1) {
  var campo = _ref1.campo,
    errors = _ref1.errors,
    strings = _ref1.strings,
    submitCount = _ref1.submitCount,
    contextoCadastroBasico = _ref1.contextoCadastroBasico,
    field = _ref1.field,
    meta = _ref1.meta;
  return !contextoCadastroBasico && /*#__PURE__*/_react["default"].createElement(_core.SttInput, _extends({
    inputProps: {
      maxLength: 255
    }
  }, field, {
    label: strings.profissao,
    required: campo.obrigatorio,
    disabled: campo.somenteLeitura,
    onInput: function onInput(e) {
      return campo.uppercase && (e.target.value = ("" + e.target.value).toUpperCase());
    },
    error: errors && (meta.touched && errors[_fieldNames.PROFISSAO] || errors[_fieldNames.PROFISSAO] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.PROFISSAO] || errors[_fieldNames.PROFISSAO] && submitCount > 0) ? errors[_fieldNames.PROFISSAO] : undefined
  }));
}), _fieldNames.PONTO_DE_REFERENCIA, function (_ref10) {
  var campo = _ref10.campo,
    errors = _ref10.errors,
    strings = _ref10.strings,
    pacientePadrao = _ref10.pacientePadrao,
    submitCount = _ref10.submitCount,
    field = _ref10.field,
    meta = _ref10.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttInput, _extends({
    inputProps: {
      maxLength: 255
    }
  }, field, {
    disabled: campo.somenteLeitura || pacientePadrao,
    onInput: function onInput(e) {
      return campo.uppercase && (e.target.value = ("" + e.target.value).toUpperCase());
    },
    required: campo.obrigatorio,
    error: errors && (meta.touched && errors[_fieldNames.PONTO_DE_REFERENCIA] || errors[_fieldNames.PONTO_DE_REFERENCIA] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.PONTO_DE_REFERENCIA] || errors[_fieldNames.PONTO_DE_REFERENCIA] && submitCount > 0) ? errors[_fieldNames.PONTO_DE_REFERENCIA] : undefined,
    label: strings.pontoDeReferencia
  }));
}), _fieldNames.LOGRADOURO, function (_ref11) {
  var campo = _ref11.campo,
    errors = _ref11.errors,
    strings = _ref11.strings,
    pacientePadrao = _ref11.pacientePadrao,
    submitCount = _ref11.submitCount,
    field = _ref11.field,
    meta = _ref11.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttInput, _extends({
    inputProps: {
      maxLength: 255
    }
  }, field, {
    disabled: campo.somenteLeitura || pacientePadrao,
    onInput: function onInput(e) {
      return campo.uppercase && (e.target.value = ("" + e.target.value).toUpperCase());
    },
    required: campo.obrigatorio,
    error: errors && (meta.touched && errors[_fieldNames.LOGRADOURO] || errors[_fieldNames.LOGRADOURO] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.LOGRADOURO] || errors[_fieldNames.LOGRADOURO] && submitCount > 0) ? errors[_fieldNames.LOGRADOURO] : undefined,
    label: strings.logradouro
  }));
}), _fieldNames.NUMERO, function (_ref12) {
  var campo = _ref12.campo,
    errors = _ref12.errors,
    strings = _ref12.strings,
    submitCount = _ref12.submitCount,
    field = _ref12.field,
    meta = _ref12.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttInput, _extends({
    inputProps: {
      maxLength: 10
    }
  }, field, {
    label: strings.numero,
    required: campo.obrigatorio,
    disabled: campo.somenteLeitura,
    onInput: function onInput(e) {
      return campo.uppercase && (e.target.value = ("" + e.target.value).toUpperCase());
    },
    error: errors && (meta.touched && errors[_fieldNames.NUMERO] || errors[_fieldNames.NUMERO] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.NUMERO] || errors[_fieldNames.NUMERO] && submitCount > 0) ? errors[_fieldNames.NUMERO] : undefined
  }));
}), _fieldNames.BAIRRO, function (_ref13) {
  var campo = _ref13.campo,
    errors = _ref13.errors,
    strings = _ref13.strings,
    pacientePadrao = _ref13.pacientePadrao,
    submitCount = _ref13.submitCount,
    field = _ref13.field,
    meta = _ref13.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttInput, _extends({
    inputProps: {
      maxLength: 30
    }
  }, field, {
    disabled: campo.somenteLeitura || pacientePadrao,
    onInput: function onInput(e) {
      return campo.uppercase && (e.target.value = ("" + e.target.value).toUpperCase());
    },
    required: campo.obrigatorio,
    error: errors && (meta.touched && errors[_fieldNames.BAIRRO] || errors[_fieldNames.BAIRRO] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.BAIRRO] || errors[_fieldNames.BAIRRO] && submitCount > 0) ? errors[_fieldNames.BAIRRO] : undefined,
    label: strings.bairro
  }));
}), _fieldNames.CEP, function (_ref14) {
  var campo = _ref14.campo,
    errors = _ref14.errors,
    strings = _ref14.strings,
    pacientePadrao = _ref14.pacientePadrao,
    submitCount = _ref14.submitCount,
    buscarEnderecoPorCep = _ref14.buscarEnderecoPorCep,
    form = _ref14.form,
    field = _ref14.field,
    meta = _ref14.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttMaskedInput, _extends({}, field, {
    mask: "cep",
    label: strings.cep,
    disabled: campo.somenteLeitura || pacientePadrao,
    required: campo.obrigatorio,
    error: errors && (meta.touched && errors[_fieldNames.CEP] || errors[_fieldNames.CEP] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.CEP] || errors[_fieldNames.CEP] && submitCount > 0) ? errors[_fieldNames.CEP] : undefined,
    onChange: function onChange(event) {
      var value = event.target.value;
      if (value && value.length === 9) {
        form.setFieldValue(_fieldNames.CEP, value);
        buscarEnderecoPorCep(value);
      }
    }
  }));
}), _fieldNames.PAIS, function (props) {
  return /*#__PURE__*/_react["default"].createElement(_pais["default"], _extends({
    strings: props.strings,
    pacientePadrao: props.pacientePadrao
  }, props, {
    errors: props.errors,
    obrigatorio: props.campo.obrigatorio,
    somenteLeitura: props.campo.somenteLeitura,
    submitCount: props.submitCount
  }));
}), _fieldNames.UF, function (props) {
  return /*#__PURE__*/_react["default"].createElement(_uf["default"], _extends({
    strings: props.strings,
    pacientePadrao: props.pacientePadrao
  }, props, {
    errors: props.errors,
    obrigatorio: props.campo.obrigatorio,
    somenteLeitura: props.campo.somenteLeitura,
    ufCep: props.ufCep,
    submitCount: props.submitCount
  }));
}), _fieldNames.MUNICIPIO, function (props) {
  return /*#__PURE__*/_react["default"].createElement(_municipio["default"], _extends({
    strings: props.strings,
    pacientePadrao: props.pacientePadrao
  }, props, {
    errors: props.errors,
    obrigatorio: props.campo.obrigatorio,
    somenteLeitura: props.campo.somenteLeitura,
    municipioCep: props.municipioCep,
    submitCount: props.submitCount
  }));
}), _fieldNames.TIPO_CONTATO_1, function (_ref15) {
  var campo = _ref15.campo,
    errors = _ref15.errors,
    strings = _ref15.strings,
    limparContato = _ref15.limparContato,
    pacientePadrao = _ref15.pacientePadrao,
    submitCount = _ref15.submitCount,
    tipoFixo = _ref15.tipoFixo,
    tipoCelular = _ref15.tipoCelular,
    field = _ref15.field,
    meta = _ref15.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttFormControl, {
    required: campo.obrigatorio,
    error: errors && (meta.touched && errors[_fieldNames.TIPO_CONTATO_1] || errors[_fieldNames.TIPO_CONTATO_1] && submitCount > 0) ? true : false,
    variant: "outlined",
    disabled: campo.somenteLeitura || pacientePadrao,
    onChange: limparContato
  }, /*#__PURE__*/_react["default"].createElement(_core.SttRadioGroup, {
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_core.SttFormControlLabel, _extends({}, field, {
    control: /*#__PURE__*/_react["default"].createElement(_core.SttRadioButton, {
      type: "radio",
      value: tipoFixo,
      color: "primary",
      checked: field.value == tipoFixo
    }),
    label: strings.telefoneFixo
  })), /*#__PURE__*/_react["default"].createElement(_core.SttFormControlLabel, _extends({}, field, {
    control: /*#__PURE__*/_react["default"].createElement(_core.SttRadioButton, {
      type: "radio",
      value: tipoCelular,
      color: "primary",
      checked: field.value == tipoCelular
    }),
    label: strings.telefoneCelular
  })), errors && (meta.touched && errors[_fieldNames.TIPO_CONTATO_1] || errors[_fieldNames.TIPO_CONTATO_1] && submitCount > 0) && /*#__PURE__*/_react["default"].createElement(_core.SttFormHelperText, {
    error: true
  }, errors[_fieldNames.TIPO_CONTATO_1])));
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_elements, _fieldNames.CONTATO_1, function (_ref16) {
  var campo = _ref16.campo,
    errors = _ref16.errors,
    strings = _ref16.strings,
    pacientePadrao = _ref16.pacientePadrao,
    submitCount = _ref16.submitCount,
    tipoCelular = _ref16.tipoCelular,
    form = _ref16.form,
    field = _ref16.field,
    meta = _ref16.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttMaskedInput, _extends({}, field, {
    mask: form.values[_fieldNames.TIPO_CONTATO_1] == tipoCelular ? 'telefoneCelular' : 'telefoneFixo',
    label: form.values[_fieldNames.TIPO_CONTATO_1] == tipoCelular ? strings.telefoneCelular : strings.telefoneFixo,
    required: campo.obrigatorio,
    error: errors && (meta.touched && errors[_fieldNames.CONTATO_1] || errors[_fieldNames.CONTATO_1] && submitCount > 0) ? true : false,
    disabled: campo.somenteLeitura || pacientePadrao,
    helperText: errors && (meta.touched && errors[_fieldNames.CONTATO_1] || errors[_fieldNames.CONTATO_1] && submitCount > 0) ? errors[_fieldNames.CONTATO_1] : undefined
  }));
}), _fieldNames.CONTATO_2, function (_ref17) {
  var campo = _ref17.campo,
    errors = _ref17.errors,
    strings = _ref17.strings,
    pacientePadrao = _ref17.pacientePadrao,
    submitCount = _ref17.submitCount,
    field = _ref17.field,
    meta = _ref17.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttMaskedInput, _extends({}, field, {
    mask: 'telefoneCelular',
    label: strings.telefoneCelular,
    required: campo.obrigatorio,
    error: errors && (meta.touched && errors[_fieldNames.CONTATO_2] || errors[_fieldNames.CONTATO_2] && submitCount > 0) ? true : false,
    disabled: campo.somenteLeitura || pacientePadrao,
    helperText: errors && (meta.touched && errors[_fieldNames.CONTATO_2] || errors[_fieldNames.CONTATO_2] && submitCount > 0) ? errors[_fieldNames.CONTATO_2] : undefined
  }));
}), _fieldNames.EMAIL, function (_ref18) {
  var campo = _ref18.campo,
    errors = _ref18.errors,
    strings = _ref18.strings,
    pacientePadrao = _ref18.pacientePadrao,
    submitCount = _ref18.submitCount,
    field = _ref18.field,
    meta = _ref18.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttInput, _extends({
    inputProps: {
      maxLength: 100
    }
  }, field, {
    required: campo.obrigatorio,
    label: strings.email,
    error: errors && (meta.touched && errors[_fieldNames.EMAIL] || errors[_fieldNames.EMAIL] && submitCount > 0) ? true : false,
    disabled: campo.somenteLeitura || pacientePadrao,
    helperText: errors && (meta.touched && errors[_fieldNames.EMAIL] || errors[_fieldNames.EMAIL] && submitCount > 0) ? errors[_fieldNames.EMAIL] : undefined
  }));
}), _fieldNames.GRUPO_SANGUINEO, function (_ref19) {
  var campo = _ref19.campo,
    errors = _ref19.errors,
    strings = _ref19.strings,
    pacientePadrao = _ref19.pacientePadrao,
    submitCount = _ref19.submitCount,
    contextoCadastroBasico = _ref19.contextoCadastroBasico,
    form = _ref19.form,
    field = _ref19.field,
    meta = _ref19.meta;
  return !contextoCadastroBasico && /*#__PURE__*/_react["default"].createElement(_core.SttAutocomplete, {
    inputprops: {
      name: field.name,
      label: strings.grupoSanguineo,
      required: campo.obrigatorio,
      error: errors && (meta.touched && errors[_fieldNames.GRUPO_SANGUINEO] || errors[_fieldNames.GRUPO_SANGUINEO] && submitCount > 0) ? errors[_fieldNames.GRUPO_SANGUINEO] : undefined
    },
    getOptionLabel: function getOptionLabel(option) {
      return option || '';
    },
    getOptionSelected: function getOptionSelected(option) {
      return option === field.value;
    },
    options: _constantes.GRUPOS_SANGUINEOS,
    value: field.value,
    onBlur: field.onBlur,
    disabled: campo.somenteLeitura || pacientePadrao,
    onChange: function onChange(e, item) {
      form.setFieldValue(_fieldNames.GRUPO_SANGUINEO, item || null);
    }
  });
}), _fieldNames.FATOR_RH, function (_ref20) {
  var campo = _ref20.campo,
    errors = _ref20.errors,
    strings = _ref20.strings,
    submitCount = _ref20.submitCount,
    pacientePadrao = _ref20.pacientePadrao,
    contextoCadastroBasico = _ref20.contextoCadastroBasico,
    form = _ref20.form,
    field = _ref20.field,
    meta = _ref20.meta;
  return !contextoCadastroBasico && /*#__PURE__*/_react["default"].createElement(_core.SttAutocomplete, {
    inputprops: {
      name: field.name,
      label: strings.fatorRh,
      required: campo.obrigatorio,
      error: errors && (meta.touched && errors[_fieldNames.FATOR_RH] || errors[_fieldNames.FATOR_RH] && submitCount > 0) ? errors[_fieldNames.FATOR_RH] : undefined
    },
    getOptionLabel: function getOptionLabel(option) {
      return option || '';
    },
    getOptionSelected: function getOptionSelected(option) {
      return option === field.value;
    },
    options: _constantes.FATORES_RH,
    value: field.value,
    onBlur: field.onBlur,
    disabled: campo.somenteLeitura || pacientePadrao,
    onChange: function onChange(e, item) {
      form.setFieldValue(_fieldNames.FATOR_RH, item || null);
    }
  });
}), _fieldNames.JUSTIFICATIVA, function (_ref21) {
  var campo = _ref21.campo,
    errors = _ref21.errors,
    strings = _ref21.strings,
    submitCount = _ref21.submitCount,
    field = _ref21.field,
    meta = _ref21.meta;
  return /*#__PURE__*/_react["default"].createElement(_core.SttInput, _extends({
    inputProps: {
      maxLength: 255
    }
  }, field, {
    label: strings.justificativa,
    required: campo.obrigatorio,
    error: errors && (meta.touched && errors[_fieldNames.JUSTIFICATIVA] || errors[_fieldNames.JUSTIFICATIVA] && submitCount > 0) ? true : false,
    helperText: errors && (meta.touched && errors[_fieldNames.JUSTIFICATIVA] || errors[_fieldNames.JUSTIFICATIVA] && submitCount > 0) ? errors[_fieldNames.JUSTIFICATIVA] : undefined
  }));
}));
var renderElement = function renderElement(formParams) {
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: formParams.campo.nome
  }, function (props) {
    var elemento = elements[formParams.campo.nome];
    return elemento(_objectSpread(_objectSpread({}, formParams), props));
  });
};
var Campos = function Campos(props) {
  var strings = props.strings,
    usarTipoContato = props.usarTipoContato,
    campos = props.campos,
    pacientePadrao = props.pacientePadrao,
    contextoCadastroBasico = props.contextoCadastroBasico,
    dadosCadastroOriginal = props.dadosCadastroOriginal,
    headers = props.headers,
    setExternalFieldValue = props.setExternalFieldValue,
    errors = props.errors,
    submitCount = props.submitCount;
  var _useFormikContext = (0, _formik.useFormikContext)(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue,
    setErrors = _useFormikContext.setErrors;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    generos = _useState2[0],
    setGeneros = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    racas = _useState4[0],
    setRacas = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    idade = _useState6[0],
    setIdade = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    tipoFixo = _useState8[0],
    setTipoFixo = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState0 = _slicedToArray(_useState9, 2),
    tipoCelular = _useState0[0],
    setTipoCelular = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    ufCep = _useState10[0],
    setUfCep = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    municipioCep = _useState12[0],
    setMunicipioCep = _useState12[1];
  var debounceTimerRef = (0, _react.useRef)(null);

  // Calcula idade
  (0, _react.useEffect)(function () {
    if (values.dataNascimento) {
      var dataMoment = (0, _moment["default"])(values.dataNascimento);
      if (dataMoment.isValid()) {
        var now = (0, _moment["default"])();
        var dataMomentFormatada = (0, _moment["default"])(dataMoment, 'DD-MM-YYYY');
        var _idade = _moment["default"].duration(now.diff(dataMomentFormatada));
        var anos = _idade.years();
        var meses = _idade.months();
        var dias = _idade.days();
        setIdade("".concat(anos, " ano(s), ").concat(meses, " mes(es) e ").concat(dias, " dia(s)"));
      }
    }
  }, [values.dataNascimento]);
  (0, _react.useEffect)(function () {
    if (!setExternalFieldValue) {
      return;
    }
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    debounceTimerRef.current = setTimeout(function () {
      setExternalFieldValue(_fieldNames.PACIENTE, values);
    }, 300);
    return function () {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [values, setExternalFieldValue]);
  (0, _react.useEffect)(function () {
    setErrors(errors);
  }, [errors]);

  // Carrega lista de gêneros e tipos de contato
  (0, _react.useEffect)(function () {
    var UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;

    // Gêneros
    _axios["default"].get("".concat(UTILITARIOS_API_BASE_URL, "/sexo")).then(function (response) {
      var data = response.data;
      if (data) {
        var itens = data.data.itens;
        setGeneros(itens);
        if (values[_fieldNames.GENERO] && values[_fieldNames.GENERO]) {
          if (Number.isInteger(values[_fieldNames.GENERO])) {
            var genero = itens.find(function (g) {
              return g.id === values[_fieldNames.GENERO];
            });
            setFieldValue(_fieldNames.GENERO, genero);
          }
        }
      } else {
        setGeneros([]);
      }
    })["catch"](function (err) {
      return console.log(err);
    });

    // Raça
    _axios["default"].get("".concat(UTILITARIOS_API_BASE_URL, "/raca"), {
      headers: headers
    }).then(function (response) {
      var data = response.data;
      if (data) {
        var itens = data.data.itens;
        setRacas(itens);

        // //Caso haja alguma raça já escolhida
        if (values[_fieldNames.RACA] && Number.isInteger(values[_fieldNames.RACA])) {
          var raca = itens.find(function (r) {
            return r.id === values[_fieldNames.RACA];
          });
          setFieldValue(_fieldNames.RACA, raca);
        }
      } else {
        setRacas([]);
      }
    })["catch"](function (err) {
      return console.log(err);
    });

    // Tipos de contato
    if (usarTipoContato) {
      _axios["default"].get("".concat(UTILITARIOS_API_BASE_URL, "/tipo-contato"), {
        headers: headers
      }).then(function (response) {
        var data = response.data;
        if (data) {
          var itens = data.data.itens;
          var fixo = itens.filter(function (t) {
            return t.categoria === _constantes.CONTATO.CATEGORIA.TELEFONE_RESIDENCIAL;
          });
          setTipoFixo(fixo[0].id);
          var celular = itens.filter(function (t) {
            return t.categoria === _constantes.CONTATO.CATEGORIA.TELEFONE_CELULAR;
          });
          setTipoCelular(celular[0].id);
          if (!values[_fieldNames.TIPO_CONTATO_1]) {
            setFieldValue(_fieldNames.TIPO_CONTATO_1, celular[0].id);
          }
        }
      })["catch"](function (err) {
        return console.log(err);
      });
    }
  }, []);
  var buscarEnderecoPorCep = function buscarEnderecoPorCep(cep) {
    cep = cep.replace(/\D/g, '');
    _axios["default"].get("https://viacep.com.br/ws/".concat(cep, "/json/")).then(function (response) {
      var data = response.data;
      if (data.erro) {
        return;
      }
      setMunicipioCep(data.ibge);
      setUfCep(data.uf);
      setTimeout(function () {
        return setFieldValue(_fieldNames.LOGRADOURO, (data.logradouro || '').substring(0, 255));
      });
      setTimeout(function () {
        return setFieldValue(_fieldNames.BAIRRO, (data.bairro || '').substring(0, 30));
      });
    })["catch"](function (err) {
      return console.log(err);
    });
  };
  var limparContato = function limparContato(e) {
    if (values[_fieldNames.TIPO_CONTATO_1] !== e.target.value) {
      setFieldValue(_fieldNames.CONTATO_1, '');
    }
  };
  return campos.map(function (linha, i) {
    return /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      container: true,
      spacing: 1,
      key: i
    }, linha.map(function (coluna) {
      var formParams = {
        campo: coluna,
        dadosCadastroOriginal: dadosCadastroOriginal,
        errors: errors,
        strings: strings,
        idade: idade,
        limparContato: limparContato,
        pacientePadrao: pacientePadrao,
        submitCount: submitCount,
        tipoFixo: tipoFixo,
        tipoCelular: tipoCelular,
        ufCep: ufCep,
        municipioCep: municipioCep,
        buscarEnderecoPorCep: buscarEnderecoPorCep,
        generos: generos,
        racas: racas,
        contextoCadastroBasico: contextoCadastroBasico
      };
      return coluna.component ? /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(coluna.component, null)) : /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
        item: true,
        xs: coluna.tamanho.xs,
        sm: coluna.tamanho.sm,
        md: coluna.tamanho.md,
        key: coluna.nome
      }, renderElement(formParams));
    }));
  });
};
Campos.propTypes = {
  strings: _propTypes["default"].object.isRequired,
  headers: _propTypes["default"].object.isRequired,
  usarTipoContato: _propTypes["default"].bool,
  campos: _propTypes["default"].array.isRequired,
  contextoCadastroBasico: _propTypes["default"].bool.isRequired,
  pacientePadrao: _propTypes["default"].bool.isRequired,
  dadosCadastroOriginal: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Campos);